import { Route, Routes } from 'react-router-dom'
import { AppShell } from './components/AppShell'
import { AccountPage } from './pages/AccountPage'
import { AskPage } from './pages/AskPage'
import { CoursePage } from './pages/CoursePage'
import { LandingPage } from './pages/LandingPage'
import { ModulePage } from './pages/ModulePage'
import { NotFoundPage } from './pages/NotFoundPage'
import { ReferencePage } from './pages/ReferencePage'
import { SearchPage } from './pages/SearchPage'

export default function App() {
  return (
    <AppShell>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/courses/:courseId" element={<CoursePage />} />
        <Route path="/modules/:moduleId" element={<ModulePage />} />
        <Route path="/search" element={<SearchPage />} />
        <Route path="/ask" element={<AskPage />} />
        <Route path="/account" element={<AccountPage />} />
        <Route path="/reference/:type" element={<ReferencePage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </AppShell>
  )
}
